import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Button from '@nubank/nuds-web/components/Button/Button';

import { Overlay, ModalCloseContent } from './style';

const ModalContent = ({ children, onModalClose, ariaId }) => {
  const { formatMessage } = useIntl();
  const handleCloseModal = event => {
    onModalClose();
    event.stopPropagation();
  };

  return (
    <Overlay
      onClick={onModalClose}
      aria-modal="true"
      aria-describedby={ariaId}
      role="document"
    >
      <ModalCloseContent>
        <Button
          variant="basic"
          styleVariant="white"
          onClick={handleCloseModal}
          iconProps={{
            name: 'x',
            title: formatMessage({ id: 'COMMON.MODAL.CLOSE_ACTION.TITLE' }),
          }}
        />
      </ModalCloseContent>
      {children}
    </Overlay>
  );
};

ModalContent.propTypes = {
  ariaId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onModalClose: PropTypes.func.isRequired,
};

export default ModalContent;
